var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMeeting = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2C7.78897 2 8.42857 2.63959 8.42857 3.42857V4.85714H15.5716V3.42857C15.5716 2.63959 16.2112 2 17.0001 2C17.7891 2 18.4287 2.63959 18.4287 3.42857V4.85714H19.8571C21.0406 4.85714 22 5.81653 22 7V19.8571C22 21.0406 21.0406 22 19.8571 22H4.14286C2.95939 22 2 21.0406 2 19.8571V7C2 5.81653 2.95939 4.85714 4.14286 4.85714H5.57143V3.42857C5.57143 2.63959 6.21103 2 7 2ZM7.35714 13.4287C7.35714 12.837 7.83684 12.3573 8.42857 12.3573H10.9286V9.85731C10.9286 9.26559 11.4083 8.78589 12 8.78589C12.5917 8.78589 13.0714 9.26559 13.0714 9.85731V12.3573H15.5714C16.1632 12.3573 16.6429 12.837 16.6429 13.4287C16.6429 14.0205 16.1632 14.5002 15.5714 14.5002H13.0714V17.0001C13.0714 17.5919 12.5917 18.0716 12 18.0716C11.4083 18.0716 10.9286 17.5919 10.9286 17.0001V14.5002H8.42857C7.83684 14.5002 7.35714 14.0205 7.35714 13.4287Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMeeting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Meeting.3ef26b4248555d02b63c3b620c1cbf69.svg";